import ReducersTooling from '../../../tooling/reducersTooling';
import MenuDescriptors from '../../../definitions/menuDescriptors';

const initialState = {
  unAuthorized: false,
  logout : ReducersTooling.initialStates.getFetchTypeInitialState(),
  userProfile: ReducersTooling.initialStates.getFetchTypeInitialState(),
  saveActualUser: ReducersTooling.initialStates.getFetchTypeInitialState(),
  mainMenu : {
    elements: MenuDescriptors.mainMenu,
    elementStates: {}
  },
  topMenu : {
    elements: MenuDescriptors.topMenu,
    elementStates: {}
  },
  onScrollBottomAction: null,
  notViewedNotificationsCount: ReducersTooling.initialStates.getFetchTypeInitialState(),
  notifications: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  notification: ReducersTooling.initialStates.getFetchTypeInitialState(),  
  downloadNotificationFile: ReducersTooling.initialStates.getFetchTypeInitialState(),
  deleteNotificationData: ReducersTooling.initialStates.getFetchTypeInitialState(),
  handleNotificationDetailPopupReference: null,
  handleCheckRouteAvailableTourReference: null,
  getCustomer: ReducersTooling.initialStates.getFetchTypeInitialState(),
  updateCustomer: ReducersTooling.initialStates.getFetchTypeInitialState(),
  stopProcess: ReducersTooling.initialStates.getFetchTypeInitialState(),
  periodsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  fixedPeriodId: "",
  setAllNotificationsViewed: ReducersTooling.initialStates.getFetchTypeInitialState(),
  getToursState: ReducersTooling.initialStates.getFetchTypeInitialState(),
  setToursStates: ReducersTooling.initialStates.getFetchTypeInitialState(),
  tourFunction: null,
  saveUserImage: ReducersTooling.initialStates.getFetchTypeInitialState(),
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/dashboard/initialState.js